import { ReactNode } from 'react';

import { ContentTypes } from '~/lib/contentful/constants/contentTypes';
import { SectionData, SectionsData, TextSectionData } from '~/lib/contentful/custom-types';
import { AdobeSplashCTASectionTemplate } from '~/old-marketing/components/sections/templates/AdobeSplashCTASectionTemplate';
import { AdobeSplashOverviewSectionTemplate } from '~/old-marketing/components/sections/templates/AdobeSplashOverviewSectionTemplate';
import { AdobeSplashTextWithVideoSectionTemplate } from '~/old-marketing/components/sections/templates/AdobeSplashTextWithVideoSectionTemplate';
import { GatedBySlugSectionTemplate } from '~/old-marketing/components/sections/templates/GatedBySlugSectionTemplate';
import { OperatorsSectionTemplate } from '~/old-marketing/components/sections/templates/OperatorsSectionTemplate/OperatorsSectionTemplate';
import { WorthlessStudiosAboutSectionTemplate } from '~/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosAboutSectionTemplate';
import { WorthlessStudiosCTASectionTemplate } from '~/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosCTASectionTemplate';
import { WorthlessStudiosEmbeddedBoardsTemplate } from '~/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosEmbeddedBoardsTemplate';
import { WorthlessStudiosOurProjectsSectionTemplate } from '~/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosOurProjectsTemplate';
import { WorthlessStudiosFreeFilmsSectionTemplate } from '~/old-marketing/components/sections/templates/WorthlessStudiosFreeFilmsSectionTemplate/WorthlessStudiosFreeFilmsSectionTemplate';
import { TextSection } from '~/old-marketing/components/sections/TextSection';

export type SectionRenderer = (section: SectionsData, index: number, isSubsection?: boolean) => ReactNode;

export const sectionRenderer: SectionRenderer = (section, index, isSubsection) => {
  if (section.__typename === 'section') {
    switch ((section as SectionData).template) {
      case AdobeSplashCTASectionTemplate.templateKey:
        return (
          <AdobeSplashCTASectionTemplate {...(section as SectionData)} isSubsection={isSubsection} key={section.id} />
        );
      case AdobeSplashOverviewSectionTemplate.templateKey:
        return (
          <AdobeSplashOverviewSectionTemplate
            {...(section as SectionData)}
            isSubsection={isSubsection}
            key={section.id}
          />
        );
      case AdobeSplashTextWithVideoSectionTemplate.templateKey:
        return (
          <AdobeSplashTextWithVideoSectionTemplate
            {...(section as SectionData)}
            isSubsection={isSubsection}
            key={section.id}
          />
        );
      case GatedBySlugSectionTemplate.templateKey:
        return <GatedBySlugSectionTemplate {...(section as SectionData)} key={section.id} />;
      case OperatorsSectionTemplate.templateKey:
        return <OperatorsSectionTemplate {...(section as SectionData)} key={section.id} />;
      case WorthlessStudiosAboutSectionTemplate.templateKey:
        return (
          <WorthlessStudiosAboutSectionTemplate
            {...(section as SectionData)}
            isSubsection={isSubsection}
            key={section.id}
          />
        );
      case WorthlessStudiosCTASectionTemplate.templateKey:
        return (
          <WorthlessStudiosCTASectionTemplate
            {...(section as SectionData)}
            isSubsection={isSubsection}
            key={section.id}
          />
        );
      case WorthlessStudiosEmbeddedBoardsTemplate.templateKey:
        return (
          <WorthlessStudiosEmbeddedBoardsTemplate
            {...(section as SectionData)}
            isSubsection={isSubsection}
            key={section.id}
          />
        );
      case WorthlessStudiosFreeFilmsSectionTemplate.templateKey:
        return (
          <WorthlessStudiosFreeFilmsSectionTemplate
            {...(section as SectionData)}
            isSubsection={isSubsection}
            key={section.id}
          />
        );
      case WorthlessStudiosOurProjectsSectionTemplate.templateKey:
        return (
          <WorthlessStudiosOurProjectsSectionTemplate
            {...(section as SectionData)}
            isSubsection={isSubsection}
            key={section.id}
          />
        );
    }
  }

  switch (section.__typename) {
    case ContentTypes.sections.shared.text:
      return (
        <TextSection {...(section as TextSectionData)} index={index} isSubsection={isSubsection} key={section.id} />
      );
  }
};
